import React from "react";
import Maintenance from "Components/ui/MaintenancePage";

const BranchAnalytics = () => {
  document.title = "Papermap | Branch Analytics";

  return (
    <React.Fragment>
      <div className="page-content">
        <Maintenance title="Branch Analytics page is under development." />
      </div>
    </React.Fragment>
  );
};

export default BranchAnalytics;
